import { provideIcons } from '@ng-icons/core'
import {
    lucideAlertCircle,
    lucideAlertTriangle,
    lucideArrowLeft,
    lucideArrowRight,
    lucideArrowUpDown,
    lucideArrowUpRight,
    lucideBan,
    lucideBarChart3,
    lucideBell,
    lucideBolt,
    lucideBookmark,
    lucideBriefcase,
    lucideBuilding,
    lucideBuilding2,
    lucideCake,
    lucideCalendar,
    lucideCalendarDays,
    lucideCamera,
    lucideCar,
    lucideCheck,
    lucideCheckCircle,
    lucideCheckCircle2,
    lucideChevronDown,
    lucideChevronRight,
    lucideCircleAlert,
    lucideClipboardList,
    lucideClock,
    lucideCreditCard,
    lucideCrosshair,
    lucideDatabase,
    lucideDollarSign,
    lucideDownload,
    lucideEye,
    lucideEyeOff,
    lucideFileText,
    lucideFilter,
    lucideFolder,
    lucideGift,
    lucideGlobe,
    lucideHand,
    lucideHeadphones,
    lucideHeart,
    lucideHelpCircle,
    lucideHome,
    lucideInbox,
    lucideInfo,
    lucideLayoutDashboard,
    lucideLayoutGrid,
    lucideLayers,
    lucideLoader2,
    lucideLogOut,
    lucideMail,
    lucideMapPin,
    lucideMenu,
    lucideMessageCircle,
    lucideMinus,
    lucideMoreVertical,
    lucidePackageOpen,
    lucidePackageSearch,
    lucidePackageX,
    lucidePartyPopper,
    lucidePencil,
    lucidePercent,
    lucidePhone,
    lucidePlus,
    lucideQrCode,
    lucideRefreshCw,
    lucideRocket,
    lucideRotateCcw,
    lucideScanLine,
    lucideSearch,
    lucideSearchX,
    lucideSend,
    lucideSettings,
    lucideShare2,
    lucideShieldCheck,
    lucideShoppingBag,
    lucideShoppingCart,
    lucideSiren,
    lucideSparkles,
    lucideStar,
    lucideStore,
    lucideTag,
    lucideTicket,
    lucideTrash2,
    lucideTrendingDown,
    lucideTrendingUp,
    lucideTrophy,
    lucideTruck,
    lucideUpload,
    lucideUser,
    lucideUserPlus,
    lucideUsers,
    lucideWallet,
    lucideX,
    lucideXCircle,
    lucideLock,
} from '@ng-icons/lucide'

export function provideBenefitAppIcons() {
    return provideIcons({
        lucideLock,
        lucideAlertCircle,
        lucideAlertTriangle,
        lucideArrowLeft,
        lucideArrowRight,
        lucideArrowUpDown,
        lucideArrowUpRight,
        lucideBan,
        lucideBarChart3,
        lucideBell,
        lucideBolt,
        lucideBookmark,
        lucideBriefcase,
        lucideBuilding,
        lucideBuilding2,
        lucideCake,
        lucideCalendar,
        lucideCalendarDays,
        lucideCamera,
        lucideCar,
        lucideCheck,
        lucideCheckCircle,
        lucideCheckCircle2,
        lucideChevronDown,
        lucideChevronRight,
        lucideCircleAlert,
        lucideClipboardList,
        lucideClock,
        lucideCreditCard,
        lucideCrosshair,
        lucideDatabase,
        lucideDollarSign,
        lucideDownload,
        lucideEye,
        lucideEyeOff,
        lucideFileText,
        lucideFilter,
        lucideFolder,
        lucideGift,
        lucideGlobe,
        lucideHand,
        lucideHeadphones,
        lucideHeart,
        lucideHelpCircle,
        lucideHome,
        lucideInbox,
        lucideInfo,
        lucideLayoutDashboard,
        lucideLayoutGrid,
        lucideLayers,
        lucideLoader2,
        lucideLogOut,
        lucideMail,
        lucideMapPin,
        lucideMenu,
        lucideMessageCircle,
        lucideMinus,
        lucideMoreVertical,
        lucidePackageOpen,
        lucidePackageSearch,
        lucidePackageX,
        lucidePartyPopper,
        lucidePencil,
        lucidePercent,
        lucidePhone,
        lucidePlus,
        lucideQrCode,
        lucideRefreshCw,
        lucideRocket,
        lucideRotateCcw,
        lucideScanLine,
        lucideSearch,
        lucideSearchX,
        lucideSend,
        lucideSettings,
        lucideShare2,
        lucideShieldCheck,
        lucideShoppingBag,
        lucideShoppingCart,
        lucideSiren,
        lucideSparkles,
        lucideStar,
        lucideStore,
        lucideTag,
        lucideTicket,
        lucideTrash2,
        lucideTrendingDown,
        lucideTrendingUp,
        lucideTrophy,
        lucideTruck,
        lucideUpload,
        lucideUser,
        lucideUserPlus,
        lucideUsers,
        lucideWallet,
        lucideX,
        lucideXCircle,
    })
}
